import React from 'react';
import {useTranslation} from 'react-i18next';
import {Controller} from 'react-hook-form';
import {TooltipCustom} from 'components/common';
import {generateGuid} from 'helpers';
import {Box, Chip, MenuItem, Select, Stack, Typography} from "@mui/material";


export default function FormInputSelectChip(props) {
  const {
    name = 'select-chips',
    control,
    label,
    variant = 'outlined',
    size = 'small',
    disabled = false,
    options = [],
    placeholder = '',
    position = 'vertical',
    sx,
    helperText,
    className,
    setValue,
    getValues,
  } = props;

  const [t, i18n] = useTranslation();
  const defaultId = !props?.id && `select-${generateGuid()}`;
  const optionKey = `${generateGuid()}-options`;

  const translateLabel = (option) => {
    let labelTranslated = option.label;

    if (i18n.exists(option.label)) {
      labelTranslated = i18n.t(option.label);
      if (labelTranslated.includes("returned an object instead of string")) labelTranslated = option.label;
    }

    return labelTranslated;
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChange = (event) => {

    const {
      target: { value },
    } = event;

    const uniqueArray = value.filter((item, index) => {
      return !value.some((elem, i) => {
        return i !== index && elem.value === item.value;
      });
    });
    setValue(name,  uniqueArray)
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        flexDirection: position === 'vertical' ? 'column' : 'row',
        alignItems: position === 'vertical' ? 'flex-start' : 'center',
        width: '100%'
      }}
    >
      {(label !== '') &&
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Typography variant="body1" id={`label-title-${defaultId}`}>
            {i18n.exists(label) ? t(label) : label}
          </Typography>
          {helperText && <TooltipCustom title={helperText}/>}
        </Box>
      }

      <Controller
        control={control}
        name={name}
        id={defaultId}
        render={({field: {onChange, value}, fieldState: {error}}) => (
          <>
            <Select
              variant={variant}
              onChange={handleChange}
              multiple
              placeholder={placeholder}
              value={value}
              disabled={!!disabled}
              size={size}
              sx={sx}
              className={className}
              error={!!error}
              renderValue={(selected) => (
                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                  {selected.map((opt, index) =>{
                    return (
                      <Chip
                        key={`${opt.value}-${opt.label}-${index}`}
                        label={opt.label}
                      />
                    )
                  }
                  )}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {options.map((option, index) => (
                <MenuItem key={`${optionKey}-${index}`} value={option} dense>
                  {translateLabel(option)}
                </MenuItem>
              ))}
            </Select>
          </>
        )}
      />
    </Box>
  )
}